import "./index.scss";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import theme from "./shared/theme/theme";
import { store } from "./src-refactor/modules/store/store";
import React, { StrictMode } from "react";
import { ModalContextProvider } from "./src-refactor/modules/shared/components/refactor/base/modal/ModalContext";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";
import { initSentry } from "./sentry";

// Inicializar Sentry
initSentry();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <SnackbarProvider maxSnack={3}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <CookiesProvider>
            <BrowserRouter>
              <ModalContextProvider>
                <App />
              </ModalContextProvider>
            </BrowserRouter>
          </CookiesProvider>
        </ThemeProvider>
      </SnackbarProvider>
    </Provider>
  </StrictMode>
);
